import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppSettings } from "src/app/model/appsettings.model";

@Injectable({ providedIn: 'root' })
export class ConfigService {

    static settings: AppSettings;

    constructor(private http: HttpClient) { }

    loadConfig() {
        const jsonFile = 'assets/settings/system.settings.json';

        return new Promise<void>((resolve, reject) => {
            this.http.get(jsonFile).toPromise().then((response: AppSettings) => {
                ConfigService.settings = <AppSettings>response;
                //console.log(ConfigService.settings);
                resolve();
            }).catch((response: any) => {
                reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
            });
        });
    }
}